"use strict";
var is_mobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
var isMobile = window.innerWidth <= 768;
document.body.setAttribute('data-device', isMobile ? 'mobile' : 'desktop');

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider();
    }
  },
  createSlider: function createSlider() {
    var featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: isMobile?"center":"left",
      wrapAround: true
    };
    $(featuredCollectionSlider).flickity({
      lazyLoad: false,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: slideData.cellAlign,
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      groupCells: 1,
      arrowShape: "M 0.6,35.5 L 37.8,-1.7 L 48.3,9.1 L 29.4,28 L 84,28 L 84,43 L 29.4,43 L 48.3,61.9 L 37.8,72.7 L 0.6,35.5 Z",
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(featuredCollectionSlider).flickity('resize');
          }, 500);
        }
      }
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};